import * as React from 'react';
import ServiceSummaryOption from '../../../../../ServiceSummary/components/ServiceSummaryOption';
import { useInsuranceGroups } from '../../lib/useInsuranceGroups';
const AggregatorInsuranceGroups = ({ items, programs, segmentId }) => {
    const productGroups = useInsuranceGroups(items, segmentId);
    const getProductName = (productItems) => {
        var _a;
        const { id, name } = productItems[0];
        return ((_a = programs.find(program => program.code === id)) === null || _a === void 0 ? void 0 : _a.name) || name;
    };
    return (React.createElement(React.Fragment, null, productGroups.map(({ items: productItems, directions }) => directions.map((direction, directionIndex) => (React.createElement(ServiceSummaryOption, { key: `${productItems[0].id}/${direction.key}`, mode: "aggregator", serviceType: "Insurance", groupOption: {
            header: directionIndex === 0 ? getProductName(productItems) : undefined,
            subheader: direction.dateLabel,
            items: direction.items
        } }))))));
};
export default AggregatorInsuranceGroups;
